import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function Footer() {

  const [formData, setFormData] = useState({
    email: '',
   
});

const [successMessage, setSuccessMessage] = useState('');
const [errors, setErrors] = useState({});

const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
        ...formData,
        [name]: type === 'checkbox' ? checked : value,
    });
};

const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};



const validateForm = () => {
    let formErrors = {};
    if (!formData.email) {
        formErrors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
        formErrors.email = 'Email is not valid';
    }
   
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
};

const handleClick = async (e) => {
    e.preventDefault();  // Prevent default form submission

    if (!validateForm()) {
        return;
    }

    const data = {
        fields: [
            { name: 'email', value: formData.email },
          
        ],
    };

    try {
        const response = await axios.post(
            'https://api.hsforms.com/submissions/v3/integration/submit/19706141/5bd8e860-cd73-49c1-b8c9-3c00c216bdc8',
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        console.log('Form submitted successfully:', response.data);

        // Clear form fields
        setFormData({
            email: '',
        });

        // Show success message
        setSuccessMessage('Form submitted successfully!');
        setErrors({});
    } catch (error) {
        console.error('Error submitting form:', error);
    }
};

  const currentYear = new Date().getFullYear();
  return (
    <div>
    <footer className="section-padding footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6">
            <div className="footer-box mb-md-40">
              <h4 className="text-custom-white fw-600">About Us</h4>
              <p className="text-custom-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.Lorem ipsum dolor sit amet... </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="footer-box mb-md-40">
              <h4 className="text-custom-white fw-600">About Us</h4>
              <ul className="m-0 p-0 main">
                <li>1-567-124-44227</li>
                <li>182 main street pert habour 8007</li>
                <li>Mon-sat 8:00-18:00 Sunday Closed</li>
              </ul>
              <ul className="custom-flex socials">
                <li><Link to="#" className="text-custom-white fs-14"><i className="fab fa-facebook-f"></i></Link></li>
                <li><Link to="#" className="text-custom-white fs-14"><i className="fa-brands fa-x-twitter"></i></Link></li>
                <li><Link to="#" className="text-custom-white fs-14"><i className="fab fa-linkedin"></i></Link></li>
                <li><Link to="#" className="text-custom-white fs-14"><i className="fab fa-youtube"></i></Link></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="footer-box mb-sm-40">
              <h4 className="text-custom-white fw-600">Newsletter</h4>
              <div className="newsletter">
                <p className="text-custom-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                {successMessage && (
                      <div className="alert alert-success mt-3 text-center" role="alert">
                          {successMessage}
                      </div>
                    )}
                  <form>
                    <div className="form-group">
                      <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control form-control-custom" placeholder="Email I'd"/>
                      {errors.email && <span className="text-danger">{errors.email}</span>}
                    </div>
                    <button type="submit" className="btn-first btn-submits" onClick={handleClick}>Subscribe</button>
                  </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <div className="copyright">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <p className="text-custom-white">© Bicycle - {currentYear} | All Right Reserved. </p>
          </div>
        </div>
      </div>
    </div>
    <div id="back-top" className="back-top"> <a href="#top"><i className="flaticon-arrows"></i></a> </div>
    </div>
  )
}

export default Footer